module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3oR2t"))).then(() => parcelRequire('d0iPb'));